import { emptyPrice } from '../components/Price'
import { clone } from 'lodash'
import { randstr } from '../../lib/Tools';

export const transportationMeans = [
  "none", 
  "airplane", 
  "bus", 
  "guide", 
  "private", 
  "rental", 
  "train", 
  "other"
]

export type TransportMeansType = "none"|"airplane"|"bus"|"guide"|"private"|"rental"|"train"|"other"

export type TransportType = {
  notes: string, 
  means: TransportMeansType, 
  from: ?string, // #WARNING is this unused, replaced by originCity?
  to: ?string, 
  price: object, 
  cost: object, 

  originCity: ?string, 
  departureStationKey: ?string, 
  departureStationCustom: ?string, 
  arrivalStationKey: ?string, 
  arrivalStationCustom: ?string, 

  // if true, the client is supposed to go to the hotel first to drop their luggage and check-in
  goToHotelFirst: ?boolean, 
}

export function getEmptyTransport (to) {
  return {
    key: randstr(),
    notes: "",
    clientNotes: "",
    means: "none",
    from: null, 
    to: to || null, 
    price: clone(emptyPrice),
    cost: clone(emptyPrice), 
  }
}

